<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Реестр образов</div>
            <a :href="route_create_page" class="title-block__btn btn-add btn-primary btn">Добавить</a>
        </div>
	</div>
	<div class="log-schedule-update-component">
		<div class="log-schedule-update-component-table-ctrls mb-4">
			<div class="filter-table__input-wrap search-control">
				<input @keyup.enter="onSearch()" @keyup.delete="onDeleteSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Поиск">
				<button @click="onSearch()" class="search-control__input-btn reset-btn">
					<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
					</svg>
				</button>
			</div>

            <filter-component :filters="filter" @filterApplied="handleFilterData" />
		</div>

		<table class="service-table table align-middle">
			<thead>
				<tr>
					<th class="col-header" scope="col" v-for="(elem, index) in thead" :key="index">
						<div style="display: flex; gap: 4px; align-items: center; justify-content: center;" class="th-inner sortable asc">
							<span style="width: 95%;">{{ elem }}</span>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="row in tbody" :key="row.id">
					<td>{{ row.tbody.name }}</td>
					<td ref="description">{{ row.tbody.description }}</td>
                    <td>{{ row.tbody.build_date }}</td>
                    <td>{{ row.tbody.device_type }}</td>
                    <td>{{ row.tbody.os }}</td>
                    <td>{{ row.tbody.device_software_version }}</td>
                    <td>{{ row.tbody.brand }}</td>
                    <td>{{ row.tbody.client }}</td>
                    <td class="align-middle">
                        <span v-if="row.is_active" class="badge rounded-pill px-3 py-2" style="background-color: #ffeef0; color: #e45a66; font-size: 13px; font-weight: 600; display: inline-flex; align-items: center;">
                            Подходит: <span class="ms-1" style="font-weight: 800;">{{ row.tbody.compatible_devices_count }}</span>
                        </span>

                        <span v-else class="badge rounded-pill px-3 py-2" style="background-color: #f1f3f5; color: #6c757d; font-size: 13px; font-weight: 600; display: inline-flex; align-items: center;">
                            Архивный образ
                        </span>
                    </td>
                    <td>{{ row.tbody.updated_at }}</td>
					<td>
                        <div class="table-action-buttons">
							<button @click="edit(row.id)" class="table-action table-action_edit m-auto align-middle" title="Редактировать"></button>
							<button @click="destroy(row.id)" class="table-action table-action_delete m-auto align-middle" title="Удалить"></button>
						</div>
                    </td>
				</tr>
			</tbody>
		</table>
	</div>

    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>
import ChangePage from '../../../../helpers/ChangePage';
import PaginationElement from '../../../../elements/PaginationElement.vue';
import { mapMutations, version } from 'vuex/dist/vuex.cjs.js';
import DeviceQuantityModal from '../../../../modals/DeviceQuantityModal.vue';
import { dateFormat } from '../../../../utilites';

import { mapState } from 'vuex/dist/vuex.cjs.js';
import { nextTick } from 'vue';
import axios from "axios";
import DeviceImages from "../../../../models/AutomaticUpdateDevices/DeviceImages";

export default {
    name: 'DeviceImagesRegistryComponent',
    props: {
        route_index: String,
        route_edit: String,
        route_create_page: String,
        route_brands_list: String,
        route_device_type_options: String,
        route_operating_systems: String,
        route_clients: String,
        route_version_options: String,
        current_page: {
            type: Number,
            default: 1
        },
    },
    components: {
        DeviceQuantityModal,
        PaginationElement,
	},

    emits: ['closeModal'],

	data() {
		return {
            deviceImage: new DeviceImages({
                route_list: this.route_index,
                route_devices_software: this.route_devices_software,
                route_client_search: this.route_clients,
            }),

			brand: null,
			brands: [],
            selectedBrand: null,

			client: null,
			clients: [],
            selectedClient: null,

			deviceType: null,
			deviceTypes: [],
            devicesModal: false,
            devices: [],
            selectedDeviceType: null,

            deviceOperatingSystem: null,
            deviceOperatingSystems: [],
            selectedDeviceOperatingSystem: null,

            version: null,
            versions: [],
            selectedVersion: null,

            date: null,

            search: null,

            lengthDescriptionCharacterSlice: 80,

			thead: [
                'Название',
                'Описание',
                'Дата сборки',
                'Тип устройства',
                'ОС',
                'Версия ПО',
                'Бренд',
                'Клиент',
                'Кол-во устройств',
                'Дата изменения',
                'Действия',
            ],

			tbody: [],

			currentSortColumn: '',
			currentSortOrder: '',

            count: 1,
            limit: 30,
            page: 1,

		}
	},

    computed: {
        ...mapState('filterComponent', ['filterState']),

        filter() {
            return [
                {
					type: 'select',
					name: 'Клиент',
					model: this.client,
					options: this.clients
				},
				{
					type: 'select',
					name: 'Бренд',
					model: this.brand,
					options: this.brands
				},
				{
					type: 'select',
					name: 'Тип устройства',
					model: this.deviceType,
					options: this.deviceTypes
				},
				{
					type: 'select',
					name: 'Версия',
					model: this.version,
					options: this.versions
				},
                {
					type: 'select',
					name: 'ОС',
					model: this.deviceOperatingSystem,
					options: this.deviceOperatingSystems
				},
				{
					type: 'date',
					name: 'Дата',
					model: null,
				},
            ]
        }
    },

	methods: {
        dateFormat,
        ...mapMutations('logs', ['setReleaseInfo']),
        loadTable: async function () {
            let response = await this.deviceImage.loadTable(
                this.page,
                this.limit,
                this.search,
                this.selectedClient,
                this.selectedBrand,
                this.selectedDeviceType,
                this.selectedDeviceOperatingSystem,
                this.selectedVersion,
                this.date,
                this.currentSortColumn,
                this.currentSortOrder
            );

            this.tbody = response.tbody;

            await this.$nextTick(() => {
                this.checkDescriptionLength();
            })

            this.count = response.pages;
            if (this.page > 1 && this.tbody.length === 0) {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },

        getBrands: async function () {
            let data = await axios.get(this.route_brands_list);
            this.brands = data.data.items;
        },
        getDeviceTypeOptions: async function() {
            const response = await axios.get(this.route_device_type_options);
            this.deviceTypes = response.data.data;
        },
        getDeviceOperatingSystems: async function () {
            const response = await axios.get(this.route_operating_systems);
            this.deviceOperatingSystems = response.data.data;
        },
        getClients: async function () {
            let clients = await this.deviceImage.clients();
            this.clients = clients.items;
        },
        getVersionOptions: async function() {
            const response = await axios.get(this.route_version_options);
            this.versions = response.data.data;
        },
        onSearch: async function () {
            this.page = 1;
            await this.loadTable()
        },
        onDeleteSearch: async function () {
            if (this.search.trim() === '') {
                this.page = 1;
                await this.loadTable()
            }
        },
        pageChange: async function (page) {
            this.page = page;
            await this.loadTable();
        },
        edit: async function (id) {
            location.href = this.route_edit.replace(0, id);
        },
        handleFilterData(data) {
            this.selectedClient = data.selectedClient ?? null;
            this.selectedBrand = data.selectedBrand ?? null;
            this.selectedDeviceType = data.selectedDeviceType ?? null;
            this.selectedVersion = data.selectedVersion ?? null;
            this.selectedDeviceOperatingSystem = data.selectedDeviceOperatingSystem ?? null;
            this.date = data.date ?? null;
            this.loadTable();
        },
        checkDescriptionLength() {
            const cells = this.$refs.description;
            if (!!cells) {
                cells.forEach(cell => {
                    if (cell.innerText.length >= this.lengthDescriptionCharacterSlice) {
                        cell.title = cell.innerText;
                        cell.innerText = cell.innerText.slice(0, this.lengthDescriptionCharacterSlice) + "…";
                        cell.style.cursor = 'help';
                    }
                });
            }
        },
        destroy: async function(id) {
            let confirmDestroy = confirm('Вы уверены что хотите удалить запись?');

            if(!confirmDestroy) {
                return;
            }

            if (confirmDestroy) {
                await axios.delete(`${this.route_index}/${id}`).then(this.loadTable)
            }
        },
	},
	mounted() {
        this.loadTable();
        this.getClients();
        this.getBrands();
        this.getDeviceTypeOptions();
        this.getDeviceOperatingSystems();
        this.getVersionOptions();
	}
}
</script>

<style scoped lang="scss">
	.title-block {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
        align-items: center;
        &__btns {
			display: flex;
            margin: 0px;
            justify-content: space-between;
            width: 100%;
        }
	}

	.page-label {
		font-size: 18px;
		font-weight: 600;
	}

	.log-schedule-update-component-table-ctrls {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 20px;
	}

	.v-selects {
		display: flex;
		flex-direction: row;
		gap: 20px;
	}

	.dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-item {
        font-size: 14px;
    }

    .dropdown-menu {
        padding: 0;
        position: absolute;
        min-width: 160px;
        border-radius: 5px;
        border: none;
        box-shadow: 0px 4px 16px 0px rgba(100, 100, 100, 0.2);
        z-index: 1;
    }

    .dropdown-menu a {
        color: black;
        padding: 8px 12px;
        text-decoration: none;
        display: block;
    }

    .dropdown-menu a:hover {
        background-color: #F1F7FF;
    }

    .table-action-buttons {
        display: flex;
        gap: 8px;
    }

	.col-header {
		font-size: 14px;
		font-weight: 600;
		color: #575F6E;
	}

	.table-popup {
		&__btn {
			display: flex;
			gap: 6px;
			background-color: #F1F6FF;
			border-radius: 4px;
			padding: 4px 6px;
			cursor: pointer;
		}
		&__check {
			@extend .table-popup__btn;
			background-color: white;
			cursor: default;
		}
	}

    .devices-status {
        min-width: 200px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        &__info {
            padding: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
            text-decoration: none;
            color: black;
            border-radius: 6px;
            transition: 0.15s;
            &:hover {
                background-color: #F1F6FF;
                transition: 0.15s;
            }
        }
    }
    .devices-status__info {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 4px 8px;
        border-radius: 4px;
    }

    .devices-status__info.active {
        cursor: pointer;
    }

    .devices-status__info.active:hover {
        background: #f8f9fa;
    }

    .devices-status__info.disabled {
        opacity: 0.6;
    }
</style>
